import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import './Badge.css';
import Card from '../Card/Card';
import BadgeSnippet from '../../snippets/BadgeSnippet/BadgeSnippet';
import { Copy } from 'lucide-react';


const HtmlText = ({ text }) => <>{text}</>;
const RsBadge = ({ value, className }) => {
  return (
    <div className='badge-wrapper'>
      Count
      <span className={`carve-badge ${className}`}>
        {value}
      </span>
    </div>
  );
};
const Badge = () => {
  const snippetContainerRef = useRef(null);
  const [showScanning, setShowScanning] = useState(false);

  const copySnippet = () => {
    if (snippetContainerRef.current) {
      const range = document.createRange();
      range.selectNode(snippetContainerRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };
  return (

    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className='flex-div'>
        <RsBadge value="9999" />
        <RsBadge value="5" />
      </div>
      <div className={`center-container ${showScanning ? 'scanning' : ''}`}>

        <div className='snippet' ref={snippetContainerRef}>
          <BadgeSnippet LeftArrow="<" RightArrow=">" ClassTitle="carve-badge badge-dark" HtmlText="9999" />
          <BadgeSnippet LeftArrow="<" RightArrow=">" ClassTitle="carve-badge badge-light" HtmlText="5" />
        </div>
        <button aria-label="Copy Button" onClick={copySnippet}>
          <Copy />
        </button>

      </div>
    </motion.div>
  )
}

const BadgeCard = () => {
  return (
    <Card
      CardTitle={<HtmlText text="Badge" />}
      CardBody={<Badge />}
    />
  )
}

export default BadgeCard;